import React, { useState, useEffect } from "react";
import "./SchedulingLink.css";
import {
  Row,
  Col,
  Button,
  Input,
  Checkbox,
  message,
} from "antd";
import { Translate } from "react-translated";
import axios from "axios";
import { TYPE_OF_SCHEDULING_CALL } from "../../../utils/Constants";

function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

const SchedulingLink = ({ parentInstance, type_of_call, schedule_meetings }) => {
  const [rows, setRows] = useState([]);
  const userType = parentInstance.props.auth.user.user_type;
  const loadingSchedulingData = async () => {
    // const { loggedin } = this.state;
    try {
      const { data } = await axios.get(`/api/meeting/links/owner/staff/bulk/fetch`, {
      });
      if (data.success) {
        setRows(data.all_meetings);
      }
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    if (userType === "EA" || userType === "LSP") {
      loadingSchedulingData();
    }
  }, [])


  const addRow = () => {
    message.destroy(); // Clear any existing messages
    // Validate all rows before adding a new one
    const hasEmptyFieldsOrInvalidLinks = rows.some(
      (row) => !row.meeting_title || !row.meeting_link || row.linkError
    );

    if (hasEmptyFieldsOrInvalidLinks) {
      message.error("Scheduling title & valid link is required with at least one call type selected");
      return;
    }

    // Check if at least one checkbox is checked in each row
    const newRows = rows.map(row => {
      if (!row.review && !row.followup && !row.prospect) {
        return { ...row, error: true };
      }
      return { ...row, error: false };
    });

    const hasUncheckedCheckboxes = newRows.some(row => row.error);

    if (hasUncheckedCheckboxes) {
      setRows(newRows);
      message.error("Please check at least one checkbox");
      return;
    }

    if (rows.length < 30) {
      setRows([...rows, { meeting_title: "", meeting_link: "", linkError: false, review: false, followup: false, prospect: false, error: false }]);
    }
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const newRows = [...rows];
    newRows[index][name] = value;

    // If the field being edited is "meeting_link", check if it's valid
    if (name === "meeting_link") {
      newRows[index].linkError = !isValidUrl(value);
    }

    // Check if at least one checkbox is checked in the current row
    const currentRow = newRows[index];
    if (!currentRow.review && !currentRow.followup && !currentRow.prospect) {
      newRows[index].error = true;
    } else {
      newRows[index].error = false;
    }

    setRows(newRows);
  };

  const handleCheckboxChange = (index, name, checked) => {
    const newRows = [...rows];
    newRows[index][name] = checked;

    // Check if at least one checkbox is checked in the current row
    const currentRow = newRows[index];
    if (currentRow.review || currentRow.followup || currentRow.prospect) {
      newRows[index].error = false;
    } else {
      newRows[index].error = true;
    }

    setRows(newRows);
  };

  const removeRow = (index, row) => {
    const rowsCopy = [...rows];
    rowsCopy.splice(index, 1);
    setRows(rowsCopy);
    parentInstance.deleteSchedule(row.id);
  };

  useEffect(() => {
    const { REVIEW, FOLLOWUP, PROSPECT } = TYPE_OF_SCHEDULING_CALL;
    parentInstance.setState({ schedule_meetings: rows });
  }, [rows, type_of_call, parentInstance]);

  const reviewsCount = rows.map(row => row.review).filter(Boolean).length;
  const followUpCount = rows.map(row => row.followup).filter(Boolean).length;
  const prospectCount = rows.map(row => row.prospect).filter(Boolean).length;

  const disabledAddBtn = () => {
    // const reviewsCount = rows.map(row => row.review).filter(Boolean).length;
    // const followUpCount = rows.map(row => row.followup).filter(Boolean).length;
    // const prospectCount = rows.map(row => row.prospect).filter(Boolean).length;

    // rows.length >= 30
    if (reviewsCount >= 10 && followUpCount >= 10 && prospectCount >= 10) {
      return true;
    } else if (rows.length >= 30) {
      return true;
    } else {
      return false;
    }
  };


  return (
    <div>
      {rows.map((row, index) => (
        <div key={index} style={{ position: "relative" }}>
          <Row
            gutter={16}
            style={{ position: "relative" }}
            className="margin-t-10"
          >
            {/* Title input */}
            <Col md={12} span={24}>
              <div>
                <label className="scheduling-label">
                  <Translate text={`Scheduling Title`} />:
                </label>
                <Input
                  type="text"
                  name="meeting_title"
                  placeholder="Scheduling Title"
                  value={row.meeting_title}
                  onChange={(e) => handleChange(index, e)}
                  maxLength={250}
                />
              </div>
            </Col>

            {/* Link input */}
            <Col md={12} span={24}>
              <div>
                <label className="scheduling-label">
                  <Translate text={`Scheduling Link`} />:
                </label>
                <Input
                  type="text"
                  name="meeting_link"
                  placeholder="Scheduling Link"
                  value={row.meeting_link}
                  onChange={(e) => handleChange(index, e)}
                  style={{ borderColor: row.linkError ? 'red' : '' }} // Conditional style
                />
                {row.linkError && (
                  <span style={{ color: "red", fontSize: "12px" }}>Invalid URL</span>
                )}
              </div>
            </Col>
          </Row>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            padding: "5px"
          }}>
            <div>
              {(reviewsCount < 10 || row.review || index < 10) && (
                <Checkbox
                  className="scheduling-checkbox"
                  checked={row.review}
                  onChange={(e) => {
                    if (reviewsCount < 10 || !e.target.checked) {
                      handleCheckboxChange(index, 'review', e.target.checked);
                    } else {
                      message.error("You cannot select 'Review' more than 10 times");
                    }
                  }}                >
                  Review
                </Checkbox>
              )}
              {(followUpCount < 10 || row.followup || index < 10) && (
                <Checkbox
                  className="scheduling-checkbox"
                  checked={row.followup}
                  onChange={(e) => {
                    if (followUpCount < 10 || !e.target.checked) {
                      handleCheckboxChange(index, 'followup', e.target.checked);
                    } else {
                      message.error("You cannot select 'Follow up' more than 10 times");
                    }
                  }} >
                  Opportunity
                </Checkbox>
              )}
              {(prospectCount < 10 || row.prospect || index < 10) && (
                <Checkbox
                  className="scheduling-checkbox"
                  checked={row.prospect}
                  onChange={(e) => {
                    if (prospectCount < 10 || !e.target.checked) {
                      handleCheckboxChange(index, 'prospect', e.target.checked);
                    } else {
                      message.error("You cannot select 'Lead' more than 10 times");
                    }
                  }}                >
                  Lead
                </Checkbox>
              )}
              {row.error && (
                <span style={{ color: "red", fontSize: "12px" }}>At least one checkbox must be checked.</span>
              )}
            </div>
            <div>
              <Button
                type="danger"
                onClick={() => removeRow(index, row)}
                className="borderRadius-28"
              >
                Remove
              </Button>
            </div>
          </div>
        </div>
      ))}

      {/* Add Row button */}
      <div className={rows.length === 0 ? "display-flex-start" : "display-flex-end"}
        style={{
          marginRight: rows.length > 0 ? "100px" : "0px",
          marginTop: rows.length > 0 ? "-35px" : "10px",
          marginBottom: "15px"
        }}
      >
        <Button
          onClick={addRow}
          className={`borderRadius-28 ${rows.length < 30 ? '' : 'disabled-btn'}`}
          disabled={disabledAddBtn()} // Disable if not all rows are valid
        >
          <Translate text={`Add Row`} />
        </Button>
      </div>
    </div>
  );
};

export default SchedulingLink;


// WEBPACK FOOTER //
// ./src/scenes/Profile/Components/SchedulingLink.js